import { types, Instance } from 'mobx-state-tree';
const { model, identifierNumber, string, number, boolean, array, maybeNull } = types;

export const UserProfileModel = model('UserProfileModel', {
  id: types.optional(identifierNumber, 0),
  name: string,
  email: string,
  lastName: maybeNull(string),
  status: number,
  permission: types.optional(string, ''),
  profileUrl: maybeNull(string),
  allPermissions: array(string),
  promptMessage: maybeNull(boolean),
  organizationName: maybeNull(string),
  passwordSet: maybeNull(boolean),
  managed: types.optional(array(string), []),
  roles: maybeNull(string),
});

export type IUserProfileModel = Instance<typeof UserProfileModel>;

export const UserOrganization = model('UserOrganization', {
  organizationName: maybeNull(string),
});

export type IUserOrganization = Instance<typeof UserOrganization>;
